/**
 * Generic centered message block used by error, empty, and not-found states.
 * Extracted to eliminate 4 identical copies across TableStates and DetailPageStates.
 */
export function CenteredMessage({ message }: { message: string }) {
  return (
    <div className="text-center py-20">
      <p className="text-text-secondary text-base">{message}</p>
    </div>
  );
}
